export const pageLoad = (url) => {
    window.uetq = window.uetq || [];
    window.uetq.push('event', 'page_view', { page_path: url });
}

export const event = (total_amount, currency, transaction_id, email, phone_number) => {
    window.email = email;
    window.phone_number = phone_number
    window.uetq = window.uetq || [];
    window.uetq.push("event", "", {"revenue_value": total_amount ,"currency": currency, "transaction_id" : transaction_id},);
}